import React, { useState, useEffect } from "react";
import arrow1 from "../arrow.svg";
import Nav from "../Include/Nav";
import arrownlblog from "../arrownlblog.svg";
import { Link } from "react-router-dom";
import Footer from "../Include/Footer1";
import border from "../borderblog.svg";
import { Helmet } from "react-helmet";

export default function Bloglist() {
  const [standings, setStandings] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchStandings = async () => {
      try {
        const response = await fetch(
          'https://dev-upkl.upkl.in/api/resource/UPKL%20Blog?fields=["*"]&title DESC'
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setStandings(data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchStandings();
  }, []);

  const breadcumb = "https://dev-upkl.upkl.in//files/breadcumb1.png";

  return (
    <>
      <Helmet>
        <title>
          Uttar Pradesh Kabaddi Updates | UPKL Latest Announcements & Mega
          Auction 2024
        </title>
        <meta
          name="title"
          content="Uttar Pradesh Kabaddi Updates | UPKL Latest Announcements & Mega Auction 2024"
        />
        <meta
          name="keywords"
          content="Uttar Pradesh Kabaddi updates
UPKL latest announcements
upkl mega auction 2024"
        />
        <meta
          name="description"
          content="Get the latest updates on Uttar Pradesh Kabaddi, including UPKL announcements and details on the UPKL Mega Auction 2024. Stay informed with the newest blog posts and insights."
        />

        <link rel="canonical" href="https://upkl.in/blog-list" />
      </Helmet>

      <Nav />
      <section className="breadcrumb">
        <img src={breadcumb} className="img-fluid" alt="UPKL BLOG" />
        <div className="breadcrumb-caption">
          <div className="d-flex">
            <div className="newarrows">
              <h2 className="text-white">UPKL BLOG</h2>
              <div className="linetilte"></div>
            </div>
            <div className="abc">
              <img src={arrow1} className="textrightarrow" alt="UPKL BLOG" />
            </div>{" "}
          </div>
        </div>
      </section>

      <section className="bloglist">
        <div className="container">
          <div className="row row1">

          <div className="col-md-3 col-12">
          <Link to="/blog-detail?name=UPKL%20announces%20BINGO%20TEDHE%20MEDHE%20as%20a%20Principal%20Sponsor%20for%C2%A0the%C2%A0endeavour">
          <div className="card">
                      <img src={border} className="img-fluid bordernew" />
                      <img
                        className="card-img-top"
                        src='https://dev-upkl.upkl.in/files/banner-857 (1).jpg
'
                        alt="Card image cap"
                      />
                      <div className="card-body">
                        <p className="card-text">
                          UPKL&nbsp;
                          <span className="text-white datetv">
                            | 18 July 2024
                          </span>
                        </p>

                        <h5 className="card-title">
                        UPKL ANNOUNCES BINGO TEDHE MEDHE AS A ..
                        </h5>

                        <div className="readmore">
                          <div className="row">
                            <div className="col-2 align-self-center">
                              <Link to="/blog-detail?name=UPKL%20announces%20BINGO%20TEDHE%20MEDHE%20as%20a%20Principal%20Sponsor%20for%C2%A0the%C2%A0endeavour">
                                {" "}
                                <button>
                                  <img src={arrownlblog} />
                                </button>
                              </Link>
                            </div>
                            <div className="col-6 align-self-center">
                              <p>&nbsp;&nbsp;Read</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>

            {standings.length > 0 ? (
              standings.map((team, index) => (
                <div className="col-md-3 col-12">
                  <Link to={`/single-blog?name=${team.name}`}>
                    <div className="card">
                      <img src={border} className="img-fluid bordernew" />
                      <img
                        className="card-img-top"
                        src={`https://dev-upkl.upkl.in/${team.short_image_blog}`}
                        alt="Card image cap"
                      />
                      <div className="card-body">
                        <p className="card-text">
                          UPKL&nbsp;
                          <span className="text-white datetv">
                            | {team.blog_date}
                          </span>
                        </p>

                        <h5 className="card-title">
                          {team.title.split(" ").slice(0, 7).join(" ")}{" "}
                          {/* Extract first 30 words */}
                          {team.title.split(" ").length > 30 ? "..." : ""}{" "}
                          {/* Add ellipsis if title exceeds 30 words */}
                          ..
                        </h5>

                        <div className="readmore">
                          <div className="row">
                            <div className="col-2 align-self-center">
                              <Link to={`/single-blog?name=${team.name}`}>
                                {" "}
                                <button>
                                  <img src={arrownlblog} />
                                </button>
                              </Link>
                            </div>
                            <div className="col-6 align-self-center">
                              <p>&nbsp;&nbsp;Read</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <p>Loading..</p>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
